module.exports = __webpack_public_path__ + "img/icon-package-supported-arrow-dark.3562ce1.svg";